import React from 'react';

import {SearchAccount} from 'src/components/account-information/components/search-account';
import {SearchTemplateUser} from 'src/components/search-template-user';

import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {ReplaceSearchesSettings} from '../../../../replace-search-settings';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';
import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    account: AccountShortInfo | undefined,
    selectedTemplateUser: UserShortInfo | undefined,
    selectedTemplateUserId: number | null,
    savedSearches: boolean,
    emailAlerts: boolean,
    templates: boolean,
    onSelectAccount: (account: AccountShortInfo | undefined) => void,
    onSetSelectedTemplateUser: (user: UserShortInfo | undefined) => void,
    setSavedSearches: (value: boolean) => void,
    setTemplates: (value: boolean) => void,
    setEmailAlerts: (value: boolean) => void,
    onFieldChange?: (parameterName: string) => void,
};

const WORKSPACES_WARNING =
    'Please, pay attention that all user\'s Workspaces will be'
    + ' unavailable after changing the user\'s account.';

export const ConfigureStep = (props: Props) => {
    const {
        account,
        selectedTemplateUser,
        selectedTemplateUserId,
        savedSearches,
        emailAlerts,
        templates,
        onSelectAccount,
        onSetSelectedTemplateUser,
        setSavedSearches,
        setTemplates,
        setEmailAlerts,
        onFieldChange,
    } = props;

    return (
        <>
            <Message color="warning">{WORKSPACES_WARNING}</Message>
            <Group direction="v" style={{padding: 24}}>
                <SearchAccount
                    label="Select Account"
                    selectedAccount={account}
                    onSelect={onSelectAccount}
                    width="100%"
                />
                <SearchTemplateUser
                    label="Import alerts & layouts from user"
                    accountId={account?.accountId}
                    selectedTemplateUser={selectedTemplateUser}
                    onSelect={onSetSelectedTemplateUser}
                    disabled={!account}
                    width="100%"
                    placeholder="Keep existing"
                />
                <ReplaceSearchesSettings {...{
                    selectedTemplateUserId,
                    savedSearches,
                    setSavedSearches,
                    templates,
                    setTemplates,
                    emailAlerts,
                    setEmailAlerts,
                    onFieldChange,
                }}
                />
            </Group>
        </>
    );
};
